import { render, staticRenderFns } from "./FieldModsTableItem.vue?vue&type=template&id=7af290c8"
import script from "./FieldModsTableItem.vue?vue&type=script&lang=js"
export * from "./FieldModsTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports